import { processError } from '../utils/processError';
import api from './index';

interface LoginDetails {
  userName: string;
  password: string;
}

interface ForgotPasswordDetails {
  username: string;
}

interface ResetPasswordDetails {
  userName: string;
  password: string;
  userType: number;
}

const login = async (details: LoginDetails) => {
  try {
    const response = await api.post(
      '/AuthenticationService/api/Authentication/Admin/SignIn',
      details
    );
    return response.data;
  } catch (e) {
    processError(e);
  }
};

const forgotPassword = async ({ username }: ForgotPasswordDetails) => {
  try {
    const response = await api.post(
      `/AuthenticationService/api/Authentication/User/ForgotPassword?username=${username}`
    );
    return response.data;
  } catch (e) {
    processError(e);
  }
};

const resetPassword = async (details: ResetPasswordDetails) => {
  try {
    const response = await api.post(
      '/AuthenticationService/api/Authentication/User/ResetPassword',
      details
    );
    return response.data;
  } catch (e) {
    processError(e);
  }
};

const authenticationApi = {
  login,
  forgotPassword,
  resetPassword,
};

export default authenticationApi;
